<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1;
  color: #2c3e50;
}
.lottery-container {
  background: #3F3AD5;
  padding: 0 15px 30px;
  text-align: center;
  color: #fff;
}
ul {
  list-style: none;
  padding: 0;
}
.lottery-bg {
  padding-right: 20px;
}
.lottery-bg img{
  width: 100%;
  min-height: 341px;
}
.count-down-title {
  font-size: 13px;
}
.lottery-count-down {
  margin-top: -68px;
}
.lottery-count-down ul {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}
.lottery-count-down ul li {
  font-size: 16px;
  width: 25px;
  height: 25px;
  line-height: 25px;
  padding: 5px;
  font-weight: bold;
}
.lottery-time {
  background: #fff;
  border-radius: 4px;
  color: #f00;
  box-shadow: 0 0.5px 5px 0px #F5A623 inset;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: sans-serif;
}
.one-chance {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #18149D;
  margin: 15px auto;
  border-radius: 10px;
  font-size: 10px;
  line-height: 14px;
  border: 1px solid #405AE9;
  box-shadow: 1px 1px 10px 0px #110e69 inset;
  position: relative;
  z-index: 1;
  &>div{
    padding-right: 10px; 
    text-align: left;
  }
}
.lottery-num {
  color: #f00;
}
.choujiang-btn {
  background: url(./assets/lottery/to-lottery.png) center center no-repeat;
  background-size: contain;
  width: 63px;
  height: 20px;
}
.lottery-seer {
  background: #18149D;
  border: 2px solid #405AE9;
  border-radius: 10px;
  position: relative;
  box-shadow: 1px 1px 10px 0px #110E69 inset;
}
.seer-title {
  height: 30px;
  margin: 10px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.seer-title li img {
  vertical-align: middle;
}
.seer-title .seer-m {
  margin: 0 20px;
}
.seer-l img, .seer-r img {
  width: 37px;
}
.seer-time-guess {
  font-size: 14px;
  margin: 0;
  padding: 2px 0;
}
.choose-btn {
  display: flex;
  justify-content: space-between;
  margin: 15px auto;
  cursor: pointer;
}
.choose-btn li {
  width: 30%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  background-size: cover;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: sans-serif;
}
.choose-btc {
  background: url("./assets/lottery/btc.png") center no-repeat;
}
.choose-eth {
  background: url("./assets/lottery/eth.png") center no-repeat;
}
.choose-eos {
  background: url("./assets/lottery/eos.png") center no-repeat;
}
.predict-once {
  color: #8493f2;
  font-size: 10px;
}
.activity-step {
  margin: 0 auto;
  text-align: left;
  font-size: 12px;
}
.activity-step li {
  line-height: 20px;
  color: #ceccff;
}
</style>
